/**
 * SHARED LEGACY CONSTANTS
 *
 * These navigation constants are used by multiple apps split from LearningCenterUI.
 * They do not belong to any single app — each app that needs them
 * imports this shared copy.
 *
 * The .legacy suffix exists to preserve git history transfer.
 */
export { HOME_URL_FRAGMENT, RESULTS_URL_FRAGMENT, TRACKS_URL_FRAGMENT, LESSONS_URL_FRAGMENT, PARTNER_TRACKS_URL_FRAGMENT, SAVED_ITEMS_URL_FRAGMENT, LEGACY_WATCH_LATER_URL_FRAGMENT, WATCH_LATER_URL_FRAGMENT, MY_PLAYLISTS_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT, PLAYLIST_RESULTS_URL_FRAGMENT, WIZARD_URL_FRAGMENT, PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, MYLEARNING_URL_FRAGMENT, LEGACY_MYLEARNING_URL_FRAGMENT, AWARD_URL_FRAGMENT, SHARE_AWARD_URL_FRAGMENT, SHARE_AWARD_PREVIEW_URL_FRAGMENT, LEGACY_AWARD_URL_FRAGMENT, LEGACY_SHARE_AWARD_URL_FRAGMENT, SHARE_ACHIEVEMENT_URL_FRAGMENT, PRACTICE_MODE_URL_FRAGMENT, MY_TEAM_URL_FRAGMENT, PROFILE_URL_FRAGMENT, EDIT_PROFILE_URL_FRAGMENT, MY_TEAM_CERTIFICATIONS_URL_FRAGMENT, MY_TEAM_MEMBERS_URL_FRAGMENT, HUBSPOT_PLAYLISTS_ADMIN_URL_FRAGMENT, AC_ONBOARDING_URL_FRAGMENT as ACADEMY_ONBOARDING_URL_FRAGMENT, AC_ASSISTANT_URL_FRAGMENT as ACADEMY_ASSISTANT_URL_FRAGMENT } from 'academy-common-lib/routes/academyRoutePaths';
import { SHORT_URL_FRAGMENT } from 'academy-common-lib/routes/academyRoutePaths';
export { SHORT_URL_FRAGMENT };
export const TRACK_INTRO_URL_FRAGMENT = 'intro';
export const TRACK_EXAM_URL_FRAGMENT = 'exam';
export const TRACK_COMPLETE_URL_FRAGMENT = 'complete';
export const TRACK_RECOMMENDATIONS_URL_FRAGMENT = 'recommendations';
export { PRE_ASSESSMENT_URL_FRAGMENT } from 'academy-common-lib/features/overview/overviewRoutingUtils';
export const TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT = 'next-in-playlist';
export const TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT = 'playlist-complete';
export const TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT = 'playlist-incomplete';
export const PRACTICAL_EXERCISE_URL_FRAGMENT = '/practical-exercise';
export const SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS = 'software-discovery';
export const PLAYLIST_CONTENT_NAVIGATION_URL_FRAGMENTS = [TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT, TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT];
export const SHORT_CONTENT_URL_FRAGMENT = `${SHORT_URL_FRAGMENT}/:shortId/:playlistNavigation(${PLAYLIST_CONTENT_NAVIGATION_URL_FRAGMENTS.join('|')})?`;
export const LEGACY_SHORT_CONTENT_URL_FRAGMENT = `${SHORT_URL_FRAGMENT}/:shortId/:language/:playlistNavigation(${PLAYLIST_CONTENT_NAVIGATION_URL_FRAGMENTS.join('|')})?`;
export const PAGE_NAMES = {
  COURSE: 'course-page',
  LESSON: 'lesson-page',
  AWARD_SHARE: 'award-share-page',
  ACHIEVEMENT_SHARE: 'achievement-share-page',
  CATALOG: 'catalog-page',
  PARTNER: 'partner-page',
  TEAM: 'my-team-page',
  MY_TEAM: 'my-team',
  MY_TEAM_CERTIFICATIONS: 'my-team-certifications-page',
  MY_TEAM_MEMBERS: 'my-team-members-page',
  MY_TEAM_CERTIFICATION_PROFILE: 'my-team-certification-profile-page',
  MY_TEAM_CERTIFICATIONS_BY_TEAM: 'my-team-certifications-by-team-page',
  MY_TEAM_PLAYLISTS: 'my-team-playlists-page',
  MY_LEARNING: 'my-learning-page',
  MY_PROFILE: 'my-profile-page',
  PROFILE: 'profile-page',
  SAVED_ITEMS: 'my-saved-items-page',
  WATCH_LATER: 'watch-later-page',
  PLAYLISTS: 'my-playlists-page',
  HUBSPOT_PLAYLISTS_ADMIN: 'hubspot-playlists-admin-page',
  WIZARD: 'wizard-page',
  SHORT_CONTENT: 'short-content-page',
  ACADEMY_ONBOARDING: 'academy-onboarding-page'
};